export default "__VITE_ASSET__BvESYj2r__"